module.exports = __webpack_public_path__ + "a2314fc9/img/ion_calendar-number.3ac5bd07.svg";